<template>
  <div>
    <h1>Work Progress Monitor</h1>
    <b-row>
      <b-col cols="12">      
        <b-table hover small responsive show-empty
          :fields="fields"
          :items="requests"
          primary-key="mdhTrackingId"
          :per-page="perPage"
          :current-page="currentPage"
          :tbody-tr-class="rowClass"
          :busy="isLoading"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc">
          <template v-slot:cell(actions)="row">
            <b-button size="sm" @click="editItem(row.item)" class="mr-1">
              edit
            </b-button>
          </template>
          <template #table-caption></template>
          <template v-slot:no-data>
            <v-btn color="primary" @click="initialize">Reset</v-btn>
          </template>

          <template v-slot:empty="scope">
            <p>No active requests found.</p>
          </template>

          <div slot="table-busy" class="text-center text-danger my-2">
              <b-spinner class="align-middle" style="margin-right:5px; margin-top:12px;"></b-spinner>
              <strong>Loading, Please Wait...</strong>
          </div>
        </b-table>
        <b-pagination
            v-if="this.requests.length > perPage"
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="fill"
            size="sm"
            class="my-0"/>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from 'axios';
import axiosRetry from 'axios-retry';
import pageTitle from '@/mixins/pageTitle'

  axiosRetry(axios, { retries: 3,
                      retryDelay: axiosRetry.exponentialDelay  });

  export default {
    title: 'Work Progress Monitor',
    data: () => ({
      perPage: 15,
      currentPage: 1,
      totalRows: 0,
      fields: [
        {key: 'mdhTrackingId', sortable: true, label: 'Number'},
        {key: 'divisionCode', sortable: true, label: 'Division'},
        {key: 'assignedName', sortable: true, label: 'Assigned To'},
        {key: 'priority', sortable: true, label: 'Priority'},
        {key: 'requestType', sortable: true, label: 'Request Type'},
        {key: 'dateAssigned', sortable: true, label: 'Assigned'},
        {key: 'requestStatus', sortable: true, label: 'Status'},
        {key: 'statusDate', sortable: true, label: 'Status Date'},
        {key: 'dueDate', sortable: true, label: 'Due Date'},
        {key: 'classification', sortable: true, label: 'Classification'},
        {key: 'hiringSupervisor', sortable: true, label: 'Supervisor'},
        {key: 'candidateName', sortable: true, label: 'Candidate'},
        {key: 'auditRoutedForApproval', sortable: true, label: 'Audit Routed'},
        {key: 'actions', label: 'Actions'},
      ],
      isLoading: false,
      requests: [],
      sortBy: 'mdhTrackingId',
      sortDesc: false,
    }),
    mixins: [
      pageTitle
    ],
    watch: {
      requests() {
        this.isLoading = false
      },
    },

    created () {
      this.fetchRequests()
    },

    methods: {
      fetchRequests() {
          this.isLoading = true;
          let fullUrl = `${process.env.VUE_APP_API_BASE_URL}/report/workingprogressreport`          
          axios.get(fullUrl)
            .then(response => {
              console.log(response.data)
                this.requests = response.data;
                this.isLoading = false;
                this.totalRows = response.data.length;
                this.setSortDetails()

            })
      },
      setSortDetails() {
        console.log(this.$store.state.workSortDetails)
        if (typeof this.$store.state.workSortDetails.sortBy !== "undefined") {
          this.sortBy = this.$store.state.workSortDetails.sortBy
        }
        if(typeof this.$store.state.workSortDetails.sortDesc !== "undefined"){
          this.sortDesc = this.$store.state.workSortDetails.sortDesc
        }
        if(typeof this.$store.state.workSortDetails.currentPage !== "undefined"){
          this.currentPage = this.$store.state.workSortDetails.currentPage
        }
      },

      editItem(item) {
        let workSortDetails = {'sortBy': this.sortBy, 'sortDesc': this.sortDesc, 'currentPage': this.currentPage}
        this.$store.dispatch('loadWorkSortDetails', workSortDetails)
        this.$router.push({ name: 'view', params: { id: item.id } })
      },
      rowClass(item, type) {
        if (!item || type !== 'row') return
        if (item.progressIndicator === 'G') return 'table-success'
        if (item.progressIndicator === 'R') return 'table-danger'
        if (item.progressIndicator === 'Y') return 'table-warning'
      }
    }
  }
</script>